import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useEffect, type ReactElement } from 'react';

import { CustomizeProvider } from '~/features/customize/customize-context';
import { useEditorUi } from '~/features/customize/editor-ui-store';

/**
 * The structure editor: the one list with its right sheet and large sheets,
 * and the recipe builder's own page for a link's answer or an insight's
 * measure. The structure is loaded once here, so the draft outlives both.
 */
function CustomizeLayout(): ReactElement {
  const { recordId } = Route.useParams();
  const reset = useEditorUi((store) => store.reset);

  // A refusal, and whatever sheet was open, belong to the record they were about.
  useEffect(() => {
    reset();
  }, [recordId, reset]);

  return (
    <CustomizeProvider recordId={recordId}>
      <Outlet />
    </CustomizeProvider>
  );
}

export const Route = createFileRoute('/_app/records/$recordId/customize')({ component: CustomizeLayout });
